module.exports = __webpack_public_path__ + "static/img/head-top_banner.d6ced47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head-top_banner.png
// module id = kIBn
// module chunks = 1